import React from 'react';
import { ImageSection } from '../Components/About/ImageSection';
import { Title } from '../Components/Ui/Title';
import { MainLayout } from '../styles/Layouts';
import { SkillsSummarySection } from '../Components/About/SkillsSummarySection';

export const About = () => {
  return (
    <MainLayout>
      <Title title={'About Me'} span={'About Me'} />
      <ImageSection />
      <SkillsSummarySection />
    </MainLayout>
  );
};
